var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "dialog-container" },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "tabular-dialog",
            value: _vm.value,
            persistent: "",
          },
          on: {
            input: function ($event) {
              return _vm.$emit("input", $event)
            },
          },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "card-background",
              attrs: { height: _vm.totalCardHeight },
            },
            [
              _c(
                "v-layout",
                { staticStyle: { "flex-direction": "column" } },
                [
                  _c(
                    "v-flex",
                    { staticStyle: { flex: "0 0 64px" } },
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { dark: "", color: "primary" } },
                        [
                          _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.close()
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("close")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticStyle: {
                            flex: "1 1 0%",
                            "min-width": "0",
                            "min-height": "0",
                          },
                        },
                        [
                          _c(
                            "v-layout",
                            { staticStyle: { height: "100%" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "card-bg-2 divider-right",
                                  style: `flex: 0 1 ${_vm.configColumnMaxLengthPixels}px; min-height: 0; min-width: 200px; display: flex; flex-direction: column;`,
                                  attrs: { xs2: "" },
                                },
                                [
                                  _c(
                                    "v-container",
                                    {
                                      staticStyle: {
                                        overflow: "auto",
                                        height: "100%",
                                      },
                                    },
                                    [
                                      _vm.loading
                                        ? [
                                            _c(
                                              "v-list",
                                              {
                                                staticStyle: {
                                                  "background-color":
                                                    "transparent",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "subheading" },
                                                  [_vm._v("Flags")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(2, function (index) {
                                                  return [
                                                    _c(
                                                      "v-list-tile",
                                                      { key: index },
                                                      [
                                                        _c(
                                                          "v-list-tile-content",
                                                          [
                                                            _c(
                                                              "v-list-tile-title",
                                                              {
                                                                staticClass:
                                                                  "loading-skeleton-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      index
                                                                    ) +
                                                                    " -\n                              "
                                                                ),
                                                                _c("small", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      index
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                }),
                                              ],
                                              2
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "v-list",
                                              {
                                                staticStyle: {
                                                  "background-color":
                                                    "transparent",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "subheading" },
                                                  [_vm._v("Flags")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.selectFlags,
                                                  function (item, i) {
                                                    return [
                                                      _c(
                                                        "v-list-tile",
                                                        { key: i },
                                                        [
                                                          _c(
                                                            "v-list-tile-content",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-tile-title",
                                                                {
                                                                  staticClass:
                                                                    "flags",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        item.FlagCode
                                                                      ) +
                                                                      " -\n                              "
                                                                  ),
                                                                  _c("small", [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          item.Description
                                                                        ) +
                                                                        "\n                                "
                                                                    ),
                                                                    !item.ShowValues &&
                                                                    !_vm.showAllValues
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "(excluded)"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        {
                                          staticStyle: {
                                            "background-color": "transparent",
                                          },
                                          attrs: { subheader: "" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "subheading mt-2" },
                                            [_vm._v("Settings")]
                                          ),
                                          _vm._v(" "),
                                          _c("v-switch", {
                                            attrs: {
                                              disabled: _vm.componentIsLoading,
                                              "hide-details": "",
                                              value: _vm.showAllValues,
                                              label:
                                                "Show values hidden by flags",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit(
                                                  "update-show-all-values",
                                                  $event || false
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "divider-bottom",
                                  staticStyle: {
                                    flex: "1 0",
                                    "min-width": "0",
                                    display: "flex",
                                    "overflow-x": "scroll",
                                  },
                                },
                                [
                                  _c("VirtualScrollTable", {
                                    ref: "dataTable",
                                    attrs: {
                                      headers: _vm.headers,
                                      isLoading: _vm.componentIsLoading,
                                      items: _vm.collectionItems,
                                      sort: _vm.sort,
                                      optimalHeight: _vm.dataTableHeight,
                                      disableSlicedHeaders: true,
                                    },
                                    on: {
                                      resize: _vm.onResize,
                                      click: _vm.showItemMenu,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (slotProps) {
                                          return [
                                            _c("SurveyTabularCell", {
                                              staticClass: "cell",
                                              attrs: {
                                                header: slotProps.header,
                                                data: slotProps.row.data,
                                                isEditing: _vm.isEditing,
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-alert",
                                              {
                                                attrs: {
                                                  type: _vm.tableAlertType,
                                                  value: _vm.showTableAlert,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.tableAlertMessage
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "card-bg-2" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  !_vm.isEditing
                    ? [
                        _vm.isTenantAdmin
                          ? _c(
                              "v-btn",
                              {
                                attrs: { small: "", color: "warning" },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateIsEditing(true)
                                  },
                                },
                              },
                              [_vm._v("Edit")]
                            )
                          : _vm._e(),
                      ]
                    : [
                        _c(
                          "v-btn",
                          {
                            attrs: { small: "", color: "primary" },
                            on: { click: _vm.saveFlags },
                          },
                          [_vm._v("Done")]
                        ),
                      ],
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { small: "", depressed: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: {
            "data-ui-component": "tabular-flags-dropdown",
            "position-x": _vm.menu.flags.x,
            "position-y": _vm.menu.flags.y,
            absolute: "",
            "offset-y": "",
            "z-index": "212",
            "close-on-content-click": false,
          },
          model: {
            value: _vm.menu.flags.show,
            callback: function ($$v) {
              _vm.$set(_vm.menu.flags, "show", $$v)
            },
            expression: "menu.flags.show",
          },
        },
        [
          _c(
            "v-list",
            { attrs: { dense: "" } },
            _vm._l(_vm.menu.flags.items, function (item, index) {
              return _c(
                "v-list-tile",
                { key: `flag-option-${index}` },
                [
                  _c(
                    "v-list-tile-action",
                    [
                      _c("v-checkbox", {
                        attrs: { value: item.FlagCode, label: item.FlagText },
                        model: {
                          value: _vm.menu.datum.Data.UpdatedFlags,
                          callback: function ($$v) {
                            _vm.$set(_vm.menu.datum.Data, "UpdatedFlags", $$v)
                          },
                          expression: "menu.datum.Data.UpdatedFlags",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }